import React from "react";
import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import Spinner from "@components/common/Spinner";
import { ICalendario } from "src/@types/Home";
import { IconCalendar } from "src/assets/iconCalendar";
import { theme } from "src/styles/theme";

type Props = {
  dataCalendar: ICalendario;
  loadingCalendar: boolean;
  onClick: (oportunidadeId: string, opportunityIdSalesforce: string) => void;
};

const CustomSchedulle = ({ dataCalendar, loadingCalendar, onClick }: Props) => {
  return (
    <>
      <VStack
        overflowY={"auto"}
        h={{ base: "120px", sm: "120px", md: "130px" }}
        css={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#D3D3D3",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#A0AEC0",
          },
          "&::-webkit-scrollbar-track": {
            background: "#F7FAFC",
          },
        }}
      >
        {loadingCalendar ? (
          <Flex h={"110px"} align={"center"} justify={"center"}>
            <Spinner />
          </Flex>
        ) : (
          <>
            {dataCalendar?.agendamentos?.length === 0 ? (
              <Flex align="center" justify="center" h={"110px"}>
                <Text
                  w={"fit-content"}
                  color={theme.text50}
                  textAlign="center"
                  fontSize={{ base: "xs", sm: "sm", md: "md" }}
                  px={2}
                >
                  Não há agendamentos nas datas selecionadas!
                </Text>
              </Flex>
            ) : (
              <>
                {dataCalendar?.agendamentos?.map(
                  (
                    {
                      dataAgendamento,
                      horaAgendamento,
                      assunto,
                      oportunidadeId,
                      opportunityIdSalesforce,
                    },
                    index
                  ) => (
                    <Flex
                      gap={{ base: 2, sm: 3, md: 4 }}
                      pb={3}
                      align={"center"}
                      key={index}
                      w="100%"
                    >
                      <Box
                        display={"flex"}
                        w={"fit-content"}
                        h={"30px"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        flexShrink={0}
                      >
                        <IconCalendar width="20" height="20" color={"#E96B73"} />
                      </Box>

                      <Box
                        display={"flex"}
                        flexDir={"column"}
                        h={"fit-content"}
                        alignItems={{
                          base: "center",
                          sm: "flex-start",
                        }}
                        cursor={"pointer"}
                        onClick={() =>
                          onClick(oportunidadeId, opportunityIdSalesforce)
                        }
                        textAlign={"left"}
                      >
                        <Text
                          fontSize={{ base: "2xs", sm: "xs", md: "sm" }}
                          color="gray.600"
                        >
                          {dataAgendamento}, {horaAgendamento}
                        </Text>
                        <Text
                          fontSize={{
                            base: "3xs",
                            sm: "2xs",
                            md: "xs",
                          }}
                          color="gray.400"
                          noOfLines={2}
                        >
                          {assunto}
                        </Text>
                      </Box>
                    </Flex>
                  )
                )}
              </>
            )}
          </>
        )}
      </VStack>
    </>
  );
};

export default CustomSchedulle;
